import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Typography
} from '@mui/material';
import React from 'react';

export default function PurchaseOrderTrackingLogsTab({ trackingLogs }) {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const getInputTypeColor = (inputType) => {
    switch (inputType?.toLowerCase()) {
      case 'manual':
        return 'warning';
      case 'automated':
      case 'api':
        return 'success';
      case 'import':
        return 'info';
      default:
        return 'default';
    }
  };

  if (!trackingLogs || trackingLogs.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h6" color="text.secondary">
          No tracking logs found
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No ZoeShipmentTrackingLogs found for this Purchase Order&apos;s
          tracking records
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        Shipment Tracking Logs ({trackingLogs.length}{' '}
        {trackingLogs.length === 1 ? 'log' : 'logs'})
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {trackingLogs.map((log) => (
          <Card key={log.Id} elevation={2} sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  mb: 2
                }}
              >
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    <Chip
                      label={log.InputType || 'Unknown'}
                      color={getInputTypeColor(log.InputType)}
                      size="small"
                      sx={{ mr: 1 }}
                    />
                    Log #{log.Id}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Collected: {formatDate(log.CollectedDate)}
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  Tracking ID: {log.ZoeShipmentTrackingId ?? 'N/A'}
                </Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                  gap: 2
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Tracking Number
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {log.TrackingNumber || 'N/A'}
                  </Typography>

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Source
                  </Typography>
                  <Typography variant="body2">{log.Source || 'N/A'}</Typography>
                </Box>

                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    User ID
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    {log.UserId || 'N/A'}
                  </Typography>

                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, color: 'text.secondary' }}
                  >
                    Input Type
                  </Typography>
                  <Typography variant="body2">
                    {log.InputType || 'N/A'}
                  </Typography>
                </Box>
              </Box>

              {log.Note && (
                <>
                  <Divider sx={{ my: 2 }} />
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}
                    >
                      Note
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        backgroundColor: 'grey.50',
                        p: 1.5,
                        borderRadius: 1,
                        border: '1px solid',
                        borderColor: 'grey.200'
                      }}
                    >
                      {log.Note}
                    </Typography>
                  </Box>
                </>
              )}
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
